import { createSelector } from '@reduxjs/toolkit';
import { ErrorLog } from '../../models/error-log.model';

const selectErrorLogState = (state: any) => state.errorLog;

export const selectErrorLogsSelector = createSelector(
    [selectErrorLogState],
    (errorLogState): { data: ErrorLog[]; total: number; page: number; per_page: number } => ({
        data: Array.isArray(errorLogState?.data) ? errorLogState.data : [],
        total: Number(errorLogState?.total || 0),
        page: Number(errorLogState?.page || 1),
        per_page: Number(errorLogState?.per_page || 10)
    })
);

export const selectErrorLogLoading = createSelector(
    [selectErrorLogState],
    (errorLogState) => !!errorLogState?.loading
);
